import type { ContentCompetency } from '@backrs_ui/common-ui';

import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

export const useAgentContext = (contentCompetencies: ContentCompetency[]) => {
  useRegisterAgentContext({
    kind: 'list',
    description: 'Browsable list of competencies grouped by unlock category',
    data: contentCompetencies,
  });
};
